import axios from 'axios';
import { getToken } from '../utils/token';

const authHeader = () => ({ Authorization: getToken() });

const formatDateParam = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const offset = d.getTimezoneOffset();
  return new Date(d.getTime() - offset * 60000).toISOString().split('T')[0];
};

export const getSentEmailsRfLocationEntryDate25 = (filterDate) => {
  const sent_at = formatDateParam(filterDate);
  return axios.get(`${process.env.REACT_APP_URL_PATH}/api/mail/sentEmails/rfLocationEntryDate25`, {
    params: sent_at ? { sent_at } : {},
    headers: authHeader(),
  });
};

export const getSentEmailsVisaInvitation55 = (filterDate) => {
  const sent_at = formatDateParam(filterDate);
  return axios.get(`${process.env.REACT_APP_URL_PATH}/api/mail/sentEmails/visaInvitation55`, {
    params: sent_at ? { sent_at } : {},
    headers: authHeader(),
  });
};

export const getRectorApprovalSentEmails = (from, to) => {
  return axios.get(`${process.env.REACT_APP_URL_PATH}/api/mail/sentEmails/rectorApproval`, {
    params: { from, to },
    headers: authHeader(),
  });
};

export const getStudentExpelledSentEmails = (filterDate) => {
  const sent_at = formatDateParam(filterDate);
  return axios.get(`${process.env.REACT_APP_URL_PATH}/api/mail/sentEmails/studentExpelled`, {
    params: sent_at ? { sent_at } : {},
    headers: authHeader(),
  });
};

export const getManualSentEmails = (filterDate) => {
  const sent_at = formatDateParam(filterDate);
  return axios.get(`${process.env.REACT_APP_URL_PATH}/api/mail/sentEmails/manual`, {
    params: sent_at ? { sent_at } : {},
    headers: authHeader(),
  });
};

export const sendRectorApproval = (studentIds) => {
  return axios.post(
    `${process.env.REACT_APP_URL_PATH}/api/mail/rectorApproval/send`,
    { students: studentIds },
    { headers: authHeader() }
  );
};

export const exportRectorApprovalDocx = async (weekStart, weekEnd) => {
  const response = await axios.get(`${process.env.REACT_APP_URL_PATH}/api/mail/rectorApproval/export`, {
    responseType: 'blob',
    params: { week_start: weekStart, week_end: weekEnd },
    headers: authHeader(),
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const fmt = (s) => s.split('-').reverse().join('.');
  link.setAttribute('download', `Согласование проректора ${fmt(weekStart)}-${fmt(weekEnd)}.docx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const exportSentEmailStudentsDocx = async (exportFileUrl, sentAt) => {
  const response = await axios.get(`${process.env.REACT_APP_URL_PATH}${exportFileUrl}`, {
    responseType: 'blob',
    headers: authHeader(),
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `Не прибыли в РФ ${sentAt}.docx`);
  document.body.appendChild(link);
  link.click();
};

// ─── Visa PDF parsing ─────────────────────────────────────────────────────────

export const parseVisaPdfs = (formData) =>
  axios.post(`${process.env.REACT_APP_URL_PATH}/api/mail/visa/parse`, formData, {
    headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
  });

export const updateStudentsFromVisa = (students) =>
  axios.post(
    `${process.env.REACT_APP_URL_PATH}/api/mail/visa/updateStudents`,
    { students },
    { headers: authHeader() }
  );

export const sendVisaEmails = ({ studentIds, subject, html, useCountryTemplate, visaPdfFilenames, originalFileNames }) =>
  axios.post(
    `${process.env.REACT_APP_URL_PATH}/api/mail/visa/send`,
    { studentIds, subject, html, useCountryTemplate, visaPdfFilenames, originalFileNames },
    { headers: authHeader() }
  );

export const getVisaParsedSentEmails = (filterDate) => {
  const sent_at = formatDateParam(filterDate);
  return axios.get(`${process.env.REACT_APP_URL_PATH}/api/mail/sentEmails/visaParsed`, {
    params: sent_at ? { sent_at } : {},
    headers: authHeader(),
  });
};
